import api from "../axios";

export const getParticularProductDetails = ({ slug }) => {
  const data = api.get("/products/getSingleProduct", {
    params: { slug },
  });
  return data;
};

export const getAllProducts = ({ offset = 0, limit = 12 }) => {
  const data = api.get("/products/getAll", {
    params: { offset, limit },
  });

  return data;
};

export const getProductDetailsForCart = (productId) => {
  const data = api.post("/products/getproductcartdetails", {
    product_id: productId,
  });

  return data;
};
